import {Component} from '@angular/core';
import {Button} from 'primeng/button';
import {RouterLink} from '@angular/router';

@Component({
  imports: [
    Button,
    RouterLink
  ],
  template: `
    <div
      class="bg-surface-200 dark:bg-surface-800 flex items-center justify-center min-h-screen min-w-screen overflow-hidden">
      <div class="w-1/4 min-w-[320px] flex flex-col items-center justify-center">
        <div class="shadow-lg w-full bg-surface-0 dark:bg-surface-900 py-8 px-8 rounded-4xl">
          <div class="text-center mb-8">
            <img src="logo.svg" class="m-auto" style="height: 128px">
          </div>
          <p class="my-4 text-center text-4xl">Page not found</p>
          <p-button
            size="large"
            label="Go back to Dashboard"
            styleClass="w-full mt-4"
            routerLink="/dashboard"/>
        </div>
      </div>
    </div>
  `
})
export class PageNotFound { }
